import * as React from "react";
import { FormHelperText, Typography } from "@mui/material";

export function CustomFormHelperDescription({ text }: { text: string }) {
	return (
		<FormHelperText>
			<Typography variant="caption" color="text.secondary">
				{" "}
				{text}
			</Typography>
		</FormHelperText>
	);
}
